import  React,  {  useEffect  }  from  'react';
import  {  useNavigate  }  from  'react-router-dom';
import  {  Box,  CircularProgress  }  from  '@mui/material';
import  {  useUser  }  from  '../../contexts/UserContext';
import  {  useAuth  }  from  '../../contexts/AuthContext';

const  RoleBasedRedirect:  React.FC  =  ()  =>  {
    const  navigate  =  useNavigate();
    const  {  isAdmin,  isManager  }  =  useUser();
    const  {  isLoading  }  =  useAuth();

    useEffect(()  =>  {
        if  (!isLoading)  {
            //  Redirect  based  on  role  priority:  Admin  >  Manager  >  Employee
            if  (isAdmin)  {
                navigate('/admin/review',  {  replace:  true  });
            }  else  if  (isManager)  {
                navigate('/manager/review',  {  replace:  true  });
            }  else  {
                navigate('/submissions',  {  replace:  true  });
            }
        }
    },  [isLoading,  isAdmin,  isManager,  navigate]);

    return  (
        <Box  display="flex"  justifyContent="center"  alignItems="center"  minHeight="100vh">
            <CircularProgress  />
        </Box>
    );
};

export  default  RoleBasedRedirect;